import { MultilivestreamState } from './types/reducerTypes'
import { AnyAction } from 'redux'

const defaultState: MultilivestreamState = {
  isLivestreamAvailable: false,
  channels: [],
  stationId: null,
  lastDayFetched: '',
}

// @TODO: Stop using AnyAction in all reducers
export default function (state = defaultState, action: AnyAction) {
  switch (action.type) {
    case 'SET_LIVESTREAM_AVAILABILITY':
      return { ...state, isLivestreamAvailable: action.payload }
    case 'SET_SCHEDULES':
      return { ...state, ...action.payload }
    case 'ADD_SCHEDULES':
      return {
        ...state,
        channels: state.channels.map((channel, index) => {
          if (channel.feed_cid === action.payload.channels[index].feed_cid) {
            return {
              ...channel,
              listings: [
                ...channel.listings,
                ...action.payload.channels[index].listings,
              ],
            }
          } else {
            return channel
          }
        }),
      }
    default:
      return state
  }
}
